import * as Sentry from '@sentry/node';

import { isClient } from 'common/utils/shared';

export const isApplePay = (): boolean => {
  try {
    return !!(isClient() && window.ApplePaySession?.canMakePayments());
  } catch (e) {
    Sentry.captureException(e);
    return false;
  }
};
